﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import React, {JSX, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import {HtmlControlProps} from "./HtmlControlProps";
import Markdown from "./Markdown";

export interface RadioProps extends HtmlControlProps<HTMLInputElement> {
	hint?: string,
	description?: string,
	descriptionOpen?: boolean,
	checked?: boolean;
	arrayKey?: string;
}

export default function Radio(props: RadioProps): JSX.Element {
	const {
		label,
		name,
		value,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		ref,
		hint,
		description,
		checked,
		arrayKey
	} = props;

	const controlId = useControlId(id);
	const hintId = controlId + "-hint";
	const hasHint = !isNullOrEmpty(hint);
	const hasDescription = !isNullOrEmpty(description);
	const klass = useMemo(() => "labelled-field" + (column ? ` ${column}` : ""), [column]);

	if (hidden) {
		return <></>;
	}

	if (hasDescription) {
		return <div className={klass}>
			<div className="form__field form__field--radio">
				<details open={props.descriptionOpen}>
					<summary>
						<input type="radio"
						       ref={ref}
						       id={controlId}
						       name={name}
						       onChange={onChange}
						       onBlur={onBlur}
						       value={value}
						       data-array-key={arrayKey}
						       tabIndex={disabled ? -1 : undefined}
						       readOnly={disabled}
						       disabled={disabled}
						       checked={onChange == null ? undefined : checked}
						       defaultChecked={onChange == null ? checked : undefined}/>
						<label className="radio__label" htmlFor={controlId}>
							<span className="label__text">{label}</span>
						</label>
						{hasHint && <span id={hintId} className="field__hint">{hint}</span>}
					</summary>
					<Markdown markdown={description} className="radio__description"/>
				</details>
			</div>
		</div>;
	}

	return <div className={klass}>
		<div className="form__field form__field--radio">
			<input type="radio"
			       ref={ref}
			       id={controlId}
			       name={name}
			       onChange={onChange}
			       onBlur={onBlur}
			       value={value}
			       data-array-key={arrayKey}
			       tabIndex={disabled ? -1 : undefined}
			       readOnly={disabled}
			       disabled={disabled}
			       checked={onChange == null ? undefined : checked}
			       defaultChecked={onChange == null ? checked : undefined}/>
			<label className="radio__label" htmlFor={controlId}>
				<span className="label__text">{label}</span>
			</label>
			{hasHint && <span id={hintId} className="field__hint">{hint}</span>}
		</div>
	</div>;
};
